import { ContentType } from '@entries/content-types'
import ContentfulContentArticle from '@entries/contentful-content-article'
import ContentfulContentArticleTab from '@entries/contentful-content-article-tab'
import { withDisplayName } from '@hocs/with-display-name'
import { Entry } from '@resolvers/entry'
import { Tabs } from '@ui/atoms/tabs'
import { graphql } from 'gatsby'
import React, { useCallback, useState } from 'react'

const ContentfulPageSectionTabsMobile: Utils.EntryFC<
  Queries.ContentfulPageSectionTabsMobileFragment
> = ({ content: { contents } }) => {
  const [value, setValue] = useState(0)

  const handleChange = useCallback((newValue: number) => {
    setValue(newValue)
  }, [])

  const hasMultipleItem = contents?.length || 0 > 1

  return (
    <>
      {hasMultipleItem && (
        <Tabs
          className="justify-center !whitespace-normal"
          items={contents?.map((item, index) => ({
            label: (
              <Entry
                key={`PageSectionMobileTab-${index}`}
                content={item}
                mapping={{
                  [ContentType.ContentfulContentArticle]:
                    ContentfulContentArticleTab,
                }}
              />
            ),
            value: index,
          }))}
          onChange={handleChange}
        />
      )}
      {contents?.map((item, index) => (
        <div
          key={`PageSectionMobileItem-${index}`}
          className={index === value ? 'block' : 'hidden'}
        >
          <Entry
            content={item}
            mapping={{
              [ContentType.ContentfulContentArticle]: ContentfulContentArticle,
            }}
          />
        </div>
      ))}
    </>
  )
}

export const query = graphql`
  fragment ContentfulPageSectionTabsMobile on ContentfulSection {
    ...ContentfulEntry
    contents {
      ...ContentfulContentArticleTab
      ...ContentfulContentArticle
    }
  }
`

export default withDisplayName(
  ContentfulPageSectionTabsMobile,
  'ContentfulPageSectionTabsMobile'
)
